import { useEffect } from "react";

export function useButtonDynamicStyles(
  textSearchBtn,
  textResetBtn,
  textCreateBtn,
  colorSearchBtn,
  colorResetBtn,
  colorCreateBtn,
  iconSearchBtn,
  iconResetBtn,
  iconCreateBtn,
  hoverSearchBtn,
  hoverResetBtn,
  hoverCreateBtn,
  textSaveBtn,
  textCancleBtn,
  colorSaveBtn,
  colorCancleBtn,
  hoverSaveBtn,
  hoverCancleBtn,
  colorEditBtns,
  hoverEditBtns
) {
  useEffect(() => {
    document.documentElement.style.setProperty(
      "--textSearchBtn",
      textSearchBtn
    );
    document.documentElement.style.setProperty("--textResetBtn", textResetBtn);
    document.documentElement.style.setProperty(
      "--textCreateBtn",
      textCreateBtn
    );
    document.documentElement.style.setProperty(
      "--colorSearchBtn",
      colorSearchBtn
    );
    document.documentElement.style.setProperty(
      "--colorResetBtn",
      colorResetBtn
    );
    document.documentElement.style.setProperty(
      "--colorCreateBtn",
      colorCreateBtn
    );
    document.documentElement.style.setProperty(
      "--iconSearchBtn",
      iconSearchBtn
    );
    document.documentElement.style.setProperty("--iconResetBtn", iconResetBtn);
    document.documentElement.style.setProperty(
      "--iconCreateBtn",
      iconCreateBtn
    );
    document.documentElement.style.setProperty(
      "--hoverSearchBtn",
      hoverSearchBtn
    );
    document.documentElement.style.setProperty(
      "--hoverResetBtn",
      hoverResetBtn
    );
    document.documentElement.style.setProperty(
      "--hoverCreateBtn",
      hoverCreateBtn
    );
    document.documentElement.style.setProperty("--textSaveBtn", textSaveBtn);
    document.documentElement.style.setProperty(
      "--textCancleBtn",
      textCancleBtn
    );
    document.documentElement.style.setProperty(
      "--colorSaveBtn",
      hoverCreateBtn
    );
    document.documentElement.style.setProperty(
      "--colorCancleBtn",
      colorCancleBtn
    );
    document.documentElement.style.setProperty("--hoverSaveBtn", hoverSaveBtn);
    document.documentElement.style.setProperty(
      "--hoverCancleBtn",
      hoverCancleBtn
    );
    document.documentElement.style.setProperty("--colorSaveBtn", colorSaveBtn);
    document.documentElement.style.setProperty(
      "--colorEditBtns",
      colorEditBtns
    );
    document.documentElement.style.setProperty(
      "--hoverEditBtns",
      hoverEditBtns
    );
  }, [
  textSearchBtn,
  textResetBtn,
  textCreateBtn,
  colorSearchBtn,
  colorResetBtn,
  colorCreateBtn,
  iconSearchBtn,
  iconResetBtn,
  iconCreateBtn,
  hoverSearchBtn,
  hoverResetBtn,
  hoverCreateBtn,
  textSaveBtn,
  textCancleBtn,
  colorSaveBtn,
  colorCancleBtn,
  hoverSaveBtn,
  hoverCancleBtn,
  colorEditBtns,
  hoverEditBtns
  ]);
}
